
const ListHeader = ({ type, amount, title }) => {
    return (
        <div className={`${type === "in" ? "text-success" : "text-danger"} 
            list-group-item bg-transparent`}
            align="center">
            <i className={`bi ${type == "in" ? "bi-arrow-down-circle-fill" : "bi-arrow-up-circle-fill"} `}></i>
            <span className=" text-uppercase px-3">
                <b>{title}</b>
            </span>
            <div><i>({amount})</i></div>
        </div>
    )
}

export default ListHeader;